import React, { useState, useEffect, useRef } from "react";
import { SelectChangeEvent } from "@mui/material";
import { useStore } from "../../store/store";
import { useAccordion } from "../../store/accordion";
import { useTheme } from "@mui/material/styles";

function useTabsSelector(
  windowOrDoor: string,
  setWindowOrDoor: (choice: string) => void,
  resetAllValues: () => void,
  // setWindowVal: (choice: string) => void
) {
  const theme = useTheme();

  const editBtn = useStore((state) => state.isEdit);

  const editRef = useRef(true);

  useEffect(() => {
    if (editBtn) return;
    editRef.current = true;
  }, [editBtn]);

  const resetText = useStore((state) => state.resetModalText);
  const clearModalText = useStore((state) => state.clearModalText);

  const [modalText, setModalText] = useState("");

  const [open, setOpen] = useState(false);

  const [reservedVal, setReservedVal] = useState("");
  const doorType = useStore((state) => state.quote.doorType);

  const addToQuote = useStore((state) => state.addToQuote);

  const checkForEmptyVals = useStore((state) => state.checkForEmptyVals);

  const handleMinimize = useAccordion((state) => state.handleMinimize);

  const unitChoiceBifoldChange = (event: SelectChangeEvent<string>) => {
    if (editBtn && !doorType.includes("Bi-fold")) return null;

    setWindowOrDoor(event.target.value);
  };

  const handleBifoldChange = (event: SelectChangeEvent<string>) => {
    if (editBtn || !doorType.includes("Bi-fold")) return null;
    const { value } = event.target;

    setWindowOrDoor(value);

    const bifold = value.replace("F", "f");
    addToQuote({
      doorType: bifold,
      stilesAndRails: "",
      stileCategory: "",
      lockRail: "",
      comboWindowConfig: "",
      comboUnitLeft: "",
      comboUnitRight: "",
      comboWindowUnitSize: "",
      comboWindowUnitSizeFraction: "",
      comboWindowHeight: "",
      comboWindowHeightFraction: ""
    });
  };

  // const handleWindowChange = (event: SelectChangeEvent<string>) => {
  //   if (editBtn || !doorType.includes("Window")) return null;
  //   const { value } = event.target;

  //   setWindowVal(value);

  //   addToQuote({ doorType: value, material: "All Aluminum" });
  // };

  const handleOpen = (text: string) => {
    setModalText(text);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handleChange = (
    event: SelectChangeEvent<unknown> | "",
    newValue: string
  ) => {
    if (
      (doorType.includes("Bi-fold") && newValue === "Bi-fold") ||
      doorType === newValue ||
      editBtn
    )
      return null;

    setReservedVal(newValue);

    const hasVals = checkForEmptyVals();

    if (hasVals) {
      handleOpen(
        "This action will reset your Existing Selections. Are you sure you want to continue?"
      );
    } else {
      if (newValue.includes("Bi-fold")) {
        const bifold = windowOrDoor?.replace("F", "f");
        addToQuote({
          doorType: bifold,
        });
      }else {
        addToQuote({ doorType: newValue });
      }
      handleMinimize();
    }
  };

  const switchTabs = () => {
    resetAllValues();
    handleMinimize();
    handleClose();
    if (reservedVal.includes("Bi-fold")) {
      const doorType = windowOrDoor?.replace("F", "f");
      return addToQuote({
        doorType,
      });
    }
    addToQuote({ doorType: reservedVal });
  };

  const [openResetModal, setOpenResetModal] = useState(false);
  const [resetModalText, setResetModalText] = useState<string[]>([]);

  useEffect(() => {
    if (!resetText || !resetText.length) return;

    if (editBtn && editRef.current === true) {
      editRef.current = false;
      return;
    }

    handleOpenReset(resetText);
  }, [resetText]);

  const handleOpenReset = (modalText: string[]) => {
    setOpenResetModal(true);
    setResetModalText(modalText);
  };

  const handleCloseReset = () => {
    setOpenResetModal(false);
    setResetModalText([]);
    clearModalText();
  };

  const tabIndex = doorType?.includes("Bi-fold") ? "Bi-fold" : doorType;

  const bifoldTabLabel = windowOrDoor.replace("F", "f").includes("Corner")
    ? "Bi-Fold Zero Corner"
    : windowOrDoor.replace("F", "f").includes("Window")
    ? "Bi-Fold Window"
    : "Bi-Fold Door";

  return {
    bifoldTabLabel,
    tabIndex,
    handleCloseReset,
    openResetModal,
    resetModalText,
    switchTabs,
    handleChange,
    handleBifoldChange,
    unitChoiceBifoldChange,
    open,
    modalText,
    theme,
    doorType,
    handleClose,
    editBtn,
    // handleWindowChange,
  };
}

export default useTabsSelector;
